
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "9bab01",
  "use": "9bab01-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"9bab01\"><path d=\"m21.834 6.708-4.542-4.542a.566.566 0 0 0-.8 0L15.25 3.408l2.271 2.27c.221.222.221.58 0 .801l-.8.8a.566.566 0 0 1-.8 0l-2.272-2.27-2 2 2.27 2.271c.221.221.221.58 0 .8l-.8.801a.566.566 0 0 1-.8 0l-2.271-2.27-2.001 2 2.27 2.271c.222.221.222.58 0 .8l-.8.8a.566.566 0 0 1-.8 0l-2.271-2.27-4.28 4.28a.566.566 0 0 0 0 .8l4.542 4.542c.22.221.58.221.8 0L21.834 7.508a.566.566 0 0 0 0-.8M7.815 19.966a.963.963 0 1 1-1.36-1.361.963.963 0 0 1 1.36 1.361\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#9bab01"/>
                </svg>
            );
        };

        Icon.id = "9bab01";

        export default Icon;
    